import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

const CHART_CONFIGS = [
    {
        key: 'genre',
        title: 'Gênero',
        categories: ['Feminino', 'Masculino', 'Outros'],
        getIndex: (user) => {
            const genre = user.genre || "";
            if (genre === "Feminino") return 0;
            if (genre === "Masculino") return 1;
            return 2;
        }
    },
    {
        key: 'age',
        title: 'Idade',
        categories: ['Até 24', '25 a 34', '35 a 44', '45 a 54', 'Mais de 55'],
        getIndex: (user) => {
            const age = parseInt(user.age || 0);
            if (age <= 24) return 0;
            if (age <= 34) return 1;
            if (age <= 44) return 2;
            if (age <= 54) return 3;
            return 4;
        }
    },
    {
        key: 'marital_status',
        title: 'Estado Civil',
        categories: ['Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 'Viúvo(a)'],
        getIndex: (user) => {
            const status = user.marital_status || "";
            if (status.includes("Solteiro")) return 0;
            if (status.includes("Casado")) return 1;
            if (status.includes("Separado") || status.includes("Divorciado")) return 2;
            if (status.includes("Viúvo")) return 3;
            return -1;
        }
    },
    {
        key: 'children',
        title: 'Filhos',
        categories: ['0', '1', '2', '3', '4+'],
        getIndex: (user) => {
            const qtd = parseInt(user.children || 0);
            if (qtd >= 4) return 4;
            return qtd;
        }
    },
    {
        key: 'income',
        title: 'Renda',
        categories: ['+ R$12.500', 'R$10.001 a R$12.500', 'R$7.501 a R$10.000', 'R$5.001 a R$7.500', 'R$2.501 a R$5.000', 'Até R$2.500'],
        getIndex: (user) => {
            const val = parseFloat(user.income || 0);
            if (val > 12500) return 0;
            if (val > 10000) return 1;
            if (val > 7500) return 2;
            if (val > 5000) return 3;
            if (val > 2500) return 4;
            return 5;
        }
    }
];

class Graficos extends Component {

    calculateSeriesData = (users, config) => {
        const total = users?.length || 0;
        if (total === 0) return Array(config.categories.length).fill(0);

        const counts = Array(config.categories.length).fill(0);

        users.forEach(user => {
            const index = config.getIndex(user);
            if (index >= 0 && index < counts.length) {
                counts[index]++;
            }
        });

        return counts.map(count => Math.round((count / total) * 100));
    };

    getChartOptions = (title, categories, dataSeries) => {
        const color = this.props.selectedArea?.color || '#4d5a31';

        return {
            chart: {
                type: 'bar',
                height: 250,
                marginLeft: 150,
                backgroundColor: 'transparent',
                style: { fontFamily: 'Arial, sans-serif' }
            },
            title: { text: '' },
            xAxis: {
                categories: categories,
                lineWidth: 0,
                lineColor: 'transparent',
                labels: {
                    style: { fontSize: '14px', color: '#666' },
                    align: 'left',
                    x: -140
                }
            },
            yAxis: {
                min: 0, max: 100,
                title: { text: null },
                gridLineWidth: 0,
                labels: { enabled: false }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        format: '{y}%',
                        style: { fontWeight: 'bold', color: '#333', fontSize: '13px', textOutline: 'none' },
                        align: 'right',
                        x: 40
                    },
                    borderWidth: 0,
                    pointWidth: 20
                }
            },
            legend: { enabled: false },
            credits: { enabled: false },
            tooltip: { pointFormat: '<b>{point.y}%</b>' },
            series: [{
                name: title,
                data: dataSeries,
                color: color
            }]
        };
    };

    render() {
        const { users } = this.props.selectedArea || { users: [] };

        return (
            <div style={{ padding: '20px', background: '#fff' }}>
                {CHART_CONFIGS.map((config) => {
                    const seriesData = this.calculateSeriesData(users, config);
                    const options = this.getChartOptions(config.title, config.categories, seriesData);

                    return (
                        <div key={config.key} style={styles.chartContainer}>
                            <h3 style={styles.title}>{config.title}</h3>
                            <HighchartsReact highcharts={Highcharts} options={options} />
                            <hr className="info-card-hr hr-mapa" />

                        </div>
                    );
                })}
            </div>
        );
    }
}

const styles = {
    chartContainer: {
        marginBottom: '40px'
    },
    title: {
        textAlign: 'center',
        color: '#666',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        marginBottom: '10px',
        textTransform: 'uppercase',
        paddingBottom: '10px'
    }
};

export default Graficos;